import PortalLearningPathUnit from '@classes/LearningPathUnit'
import { Content, ContentLabel, ContentList, StyledScroller } from '@layouts/LearningPath/Chapter/style'
import DetailTabs from '@layouts/LearningPath/DetailTabs'
import React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  showDetails: boolean
  tab: number
  title: string
  content?: string
}

const ChapterContent: React.FC<Props> = ({ showDetails, tab, title, content }) => (
  <Content tab={tab} showDetails={showDetails}>
    <StyledScroller>
      <ContentLabel>
        <FormattedMessage id={title} />
      </ContentLabel>
      {content && (
        <ContentList>
          <li>
            <span dangerouslySetInnerHTML={{ __html: content }}></span>
          </li>
        </ContentList>
      )}
    </StyledScroller>
  </Content>
)

const ChapterDetails: React.FC<{ Unit: PortalLearningPathUnit; showDetails: boolean }> = ({ Unit, showDetails }) => (
  <DetailTabs role={Unit.DetailsType} activeTab={1}>
    <ChapterContent tab={1} showDetails={showDetails} title="Vocabulary & Expressions" content={Unit.Vocabularies} />
    <ChapterContent tab={2} showDetails={showDetails} title="Grammar" content={Unit.GrammarItem} />
    <ChapterContent tab={3} showDetails={showDetails} title="Topics" />
    <ChapterContent tab={4} showDetails={showDetails} title="Objectives" />
  </DetailTabs>
)

export default ChapterDetails
